import { createI18n } from "vue-i18n";
import zh from './zh'
import en from './en'
import jp from './jp'
 
const i18n = createI18n({
  locale:localStorage.getItem('language') || 'zh', // 默认是中文
  globalInjection:true,//全局配置$t
  legacy:false,
  messages:{en,zh,jp},// 需要做国际化的语种
  warnHtmlMessage: false,
})
 
export default i18n